export default {
  navigationHistory: {
    lastVisitedRoute: '',
  },
};
